// object types
export const WALL = 'wall';
export const ROOF = 'roof';
export const FLOOR = 'floor';
export const GABLE = 'gable';
export const DOOR = 'door';
export const DOOR_CANOPY = 'canopy';
export const GATE = 'gate';
export const WINDOW = 'window';
export const WALL_LIGHTBAND = 'wall_lightband';
export const GLASS_ELEMENT = 'glass_element';
